import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { VettingService } from "../../../../../../services/vetting/vetting.service";
import {
    VetClientModel,
    SubtaskCorrespondenceEmailModel,
    RuleConfigBroker
} from "../../../../../../models/vetting/vetting.models";
import {
    NotificationClientService,
    NotificationType
} from "../../../../../../services/basics/notification-client.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { VesselDetailModel } from "../../../../../../models/vessels/vessel.models";
import { ValidationController, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";

@autoinject
@transient()
export class AddVetTaskDialog {

    public vet: VetClientModel;
    vetId: number;
    description: string;
    actionToTake: string;
    title: string;
    ruleActionId: number;
    onConfirm: () => void;

    configBroker: RuleConfigBroker = {
        model: {}
    };

    constructor(private dialogClientService: DialogClientService, private vettingService: VettingService, private notificationService: NotificationClientService,
        private validationController: ValidationController, private validationsClientService: ValidationsClientService) {
        this.validationController.addRenderer(new CustomValidationRenderer())
    }

    activate(data: { vetRequiresMoreInformationEmails: SubtaskCorrespondenceEmailModel[], vessel: VesselDetailModel, onConfirm: () => void, vet: VetClientModel, onViewVet: (id: number) => void }) {
        this.onConfirm = data.onConfirm;
        this.vet = data.vet;
        this.vetId = this.vet.vetId;
        this.addValidations();
    }

    addValidations() {
        ValidationRules
            .ensure<AddVetTaskDialog, string>(x => x.title)
            .displayName('Title')
            .required()
            .ensure<string>(x => x.description)
            .displayName('Description')
            .required()
            .on(this)
    }

    close() {
        this.dialogClientService.hide();
    }

    getSelectedItem($event){

        this.configBroker.model.category = $event?.detail?.item?.name;
     }

    async submit() {
        try {
            if (this.configBroker.onSubmit){
                const valid = this.configBroker.onSubmit();
                if(!valid) return;
            }
            const validation = await this.validationController.validate();
            if (!validation.valid) return;

            const response = await this.vettingService.saveVetTask(this.vet.vetId, {
                meta: JSON.stringify(this.configBroker.model),
                title: this.title,
                description: this.description,
                actionToTake: this.actionToTake,
                ruleActionId: this.ruleActionId
            });
            if (response.validationResult && response.validationResult.hasError) {
                this.validationsClientService.showValidationErrors(response.validationResult);
                return;
            }
            if (this.onConfirm)
                this.onConfirm();
            this.close();
        } catch (response) {
            if (response.validationResult && response.validationResult.hasError) {
                this.validationsClientService.showValidationErrors(response.validationResult);
            } else if (!RequestClientService.isExceptionHandled(response)) {
                this.notificationService.show("Error adding vet task", "", NotificationType.Error);
            }
        }
    }
}
